'use client';

import { c as _c } from "react/compiler-runtime";
import { Icon, Image } from '@petsmart-ui/sparky';
import { useEffect, useRef, useState } from 'react';
import { decodeEntityString } from '@libs/algolia';
import { useDecisions } from '@libs/common-next';
import type { OptexSearchBiaGuestProduct } from './use-optex-search-bia-guest';
import './optex-search-bia-guest.scss';
type OptexSearchBiaGuestProps = Readonly<{
  query: string;
  products?: OptexSearchBiaGuestProduct[] | null;
}>;
const OPTEX_SEARCH_BIA_GUEST_SCROLL_DISTANCE = 312;
export function OptexSearchBiaGuest(t0) {
  const $ = _c(18);
  const {
    query,
    products
  } = t0;
  const isOptexSearchBiaGuestEnabled = useDecisions("search_bia_guest");
  const optexRailRef = useRef(null);
  const [canScrollBack, setCanScrollBack] = useState(false);
  const [canScrollForward, setCanScrollForward] = useState(false);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      const optexRail = optexRailRef.current;
      if (!optexRail) {
        return;
      }
      const updateOptexScrollControls = () => {
        setCanScrollBack(optexRail.scrollLeft > 0);
        setCanScrollForward(optexRail.scrollLeft + optexRail.clientWidth < optexRail.scrollWidth - 1);
      };
      updateOptexScrollControls();
      optexRail.addEventListener("scroll", updateOptexScrollControls);
      window.addEventListener("resize", updateOptexScrollControls);
      return () => {
        optexRail.removeEventListener("scroll", updateOptexScrollControls);
        window.removeEventListener("resize", updateOptexScrollControls);
      };
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== isOptexSearchBiaGuestEnabled || $[2] !== products || $[3] !== query) {
    t2 = [products, isOptexSearchBiaGuestEnabled, query];
    $[1] = isOptexSearchBiaGuestEnabled;
    $[2] = products;
    $[3] = query;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  useEffect(t1, t2);
  if (!isOptexSearchBiaGuestEnabled || query !== "" || !products?.length) {
    return null;
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <h2 className="optex-search-bia-guest__title" id="optex-search-bia-guest-title">Most-loved essentials</h2>;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== products) {
    t4 = products.map(_temp);
    $[6] = products;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t4) {
    t5 = <ul ref={optexRailRef} className="optex-search-bia-guest__rail" aria-label="Most-loved essentials products">{t4}</ul>;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== canScrollBack) {
    t6 = canScrollBack && <button aria-label="Previous Most-loved essentials products" className="optex-search-bia-guest__arrow optex-search-bia-guest__arrow--back" type="button" onClick={() => optexRailRef.current?.scrollBy({
      left: -OPTEX_SEARCH_BIA_GUEST_SCROLL_DISTANCE,
      behavior: "smooth"
    })}><Icon name="chevron-left" /></button>;
    $[10] = canScrollBack;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== canScrollForward) {
    t7 = canScrollForward && <button aria-label="Next Most-loved essentials products" className="optex-search-bia-guest__arrow optex-search-bia-guest__arrow--forward" type="button" onClick={() => optexRailRef.current?.scrollBy({
      left: OPTEX_SEARCH_BIA_GUEST_SCROLL_DISTANCE,
      behavior: "smooth"
    })}><Icon name="chevron-right" /></button>;
    $[12] = canScrollForward;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t5 || $[15] !== t6 || $[16] !== t7) {
    t8 = <section className="optex-search-bia-guest" aria-labelledby="optex-search-bia-guest-title">{t3}<div className="optex-search-bia-guest__carousel">{t5}{t6}{t7}</div></section>;
    $[14] = t5;
    $[15] = t6;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  return t8;
}
function _temp(optexProduct, index) {
  return <li className="optex-search-bia-guest__item" key={`${optexProduct.sku}-${index}`}><a className="optex-search-bia-guest__link" href={optexProduct.href}><Image className="optex-search-bia-guest__image" src={optexProduct.imageUrl} alt="" width={96} height={96} loading="lazy" /><span className="optex-search-bia-guest__name">{decodeEntityString(optexProduct.name)}</span></a></li>;
}